import React, { useEffect, createElement } from 'react';
import { HeroSection } from './components/HeroSection';
import { VideoPreview } from './components/VideoPreview';
import { Testimonials } from './components/Testimonials';
import { PainPoints } from './components/PainPoints';
import { TargetAudience } from './components/TargetAudience';
import { SystemOverview } from './components/SystemOverview';
import { TomosSlider } from './components/TomosSlider';
import { BonosSlider } from './components/BonosSlider';
import { ComparisonTable } from './components/ComparisonTable';
import { PricingSection } from './components/PricingSection';
import { PlusUpsell } from './components/PlusUpsell';
import { Guarantee } from './components/Guarantee';
import { FAQAccordion } from './components/FAQAccordion';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    // Safe initialization of Meta Pixel that avoids 'parentNode' errors
    // by appending directly to document.head instead of looking for existing scripts
    const win = window as any;
    if (!win.fbq) {
      win.fbq = function () {
        win.fbq.callMethod ? win.fbq.callMethod.apply(win.fbq, arguments) : win.fbq.queue.push(arguments);
      };
      if (!win._fbq) win._fbq = win.fbq;
      win.fbq.push = win.fbq;
      win.fbq.loaded = true;
      win.fbq.version = '2.0';
      win.fbq.queue = [];
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);
    }
    win.fbq('init', '937331855399019');
    win.fbq('track', 'PageView');
  }, []);
  return <div className="min-h-screen bg-white font-sans text-gray-900 selection:bg-medical-blue selection:text-white" data-id="element-0">
      <HeroSection data-id="element-1" />
      <VideoPreview data-id="element-2" />
      <Testimonials data-id="element-3" />
      <PainPoints data-id="element-4" />
      <TargetAudience data-id="element-5" />
      <SystemOverview data-id="element-6" />
      <TomosSlider data-id="element-7" />
      <BonosSlider data-id="element-8" />
      <ComparisonTable data-id="element-9" />
      <PricingSection data-id="element-10" />
      <PlusUpsell data-id="element-11" />
      <Guarantee data-id="element-12" />
      <FAQAccordion data-id="element-13" />
      <FinalCTA data-id="element-14" />
      <Footer data-id="element-15" />
    </div>;
}